import React from 'react';
import './PageSubTitle.css';

const PageSubTitle = ({ text, alignText = 'left' }) => {
  const className = `pageSubTitle ${alignText || ''}`;
  return <h2 className={className}>{text}</h2>;
};

export default PageSubTitle;
